<script lang="ts">
    import Fa from 'svelte-fa'
    import { faSignature } from '@fortawesome/free-solid-svg-icons'

    export let data: Record<string, any>
</script>

<div class="block-preview">
    <Fa icon={faSignature} />
    <span>Área de assinatura</span>
</div>

<style>
    .block-preview {
        max-width: 360px;
        height: 72px;
        border: 1px dashed #c7cdd4;
        border-radius: 8px;
        background: #f8f9fa;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        color: #868e96;
        font-size: 0.88rem;
    }
</style>
